import { NavLink } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function MobileNav() {
  const { profile } = useAuth();
  const isAdmin = profile?.role === "admin";

  const nav = isAdmin
    ? [
        { to: "/dashboard", label: "Home" },
        { to: "/patients", label: "Add Patient" },
        { to: "/admin", label: "Admin" },
        { to: "/admin/users", label: "Users" },
        { to: "/admin/audit-logs", label: "Logs" },
      ]
    : [
        { to: "/dashboard", label: "Home" },
        { to: "/patients", label: "Add Patient" },
        { to: "/request-access", label: "Access" },
      ];

  return (
    <nav className="mobile-nav">
      {nav.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `mobile-nav-link ${isActive ? "active" : ""}`}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
